export default __webpack_public_path__ + "static/media/intel9900k.40b7fb38.jpg";